import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-door-right-lock',
  templateUrl: './door-right-lock.component.html',
  styleUrls: ['./door-right-lock.component.scss']
})
export class DoorRightLockComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
